import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

import SignButton from './SignButton';
import styles from './styles.module.scss';

interface OwnProps {
	showRejectButton: boolean;
	showSignButton: boolean;
	onRejectButtonClick: () => void;
	onSignButtonClick: () => void;
	hasOverlaps: boolean;
}

const TimeSheetApprovalActions = (props: OwnProps) => {
	const { showSignButton, showRejectButton, onRejectButtonClick, onSignButtonClick, hasOverlaps } = props;

	return (
		<div className={styles['approval-actions']}>
			{showRejectButton &&
				<Button
					label="Reject"
					onClick={onRejectButtonClick}
					style="danger"
				/>
			}
			{showSignButton &&
				<SignButton
					hasOverlaps={hasOverlaps}
					showSignatureModal={onSignButtonClick}
				/>
			}
		</div>
	);
};

export default TimeSheetApprovalActions;
